<template>
  <div>
    <p class="mb-5">{{ 'employees.form.new-employment-description' | translate }}</p>

    <form-input-container title='Arbeidsverhouding' text='Vul de gegevens arbeidsverhouding yada'>
      <div class='hf fl mb-4' style='width: 49%;' >
        <text-field  v-model="employeeNumber" :errors="relationshipValidations.messagesFor('employeeNumber')"
          :label="'employee.personel-number' | translate">
          <v-icon slot='left'>person</v-icon>
        </text-field>
      </div>

      <div class='hf fl'>
        <date-picker v-model="fromDate" :label="'employee.employment-from-date' | translate" style='width: 400px' class='mr-4' />
        <date-picker v-model="untilDate" :errors="relationshipValidations.messagesFor('untilDate')"
          :label="'employee.employment-until-date' | translate" style='width: 400px' optional right :min="fromDate" clearable/>
      </div>
    </form-input-container>

    <form-input-container title='Eerste Ziekdag' text='Is de werknemer ziek geweest op de datum indienst?'>
       <RadioGroup>
        <RadioGroupItem :selected="absenceOnFromDate === false" :click="() => absenceOnFromDate = false" class="mr-4">{{ 'employees.form.no-absence-on-employment-from-date' | translate}}</RadioGroupItem>
        <RadioGroupItem :selected="absenceOnFromDate === true" :click="() => absenceOnFromDate = true">{{ 'employees.form.yes-absence-on-employment-from-date' | translate}}</RadioGroupItem>
      </RadioGroup>
    </form-input-container>

    <form-input-container title='Kenmerken' text='De kenmerken van de arbeidsverhouding'>
      <div class='fl hf mb-4'>
        <!-- <date-picker v-model="detailFromDate" :label="'employee.characteristics-from-date' | translate" class='mr-4 hf' :min="fromDate"/> -->
        <dropdown v-model="natureOfEmployment" :label="'employee.kind-of-employment' | translate" class='mr-4' >
          <option v-for="p in naturesOfEmployment" :key="p + '-option'" :value="p">
            {{ 'nature-of-employment.'+p | translate}}
          </option>
        </dropdown>

        <dropdown v-model="professionClassification" :label="'employee.profession-classification' | translate">
          <option v-for="p in professionClassifications" :key="p + '-option'" :value="p">
            {{ 'profession-classification.'+p | translate}}
          </option>
        </dropdown>
      </div>

      <div class='fl hf'>
        <text-field v-model='grossAnnualSalary' @change="handleSalaryChanged" right
          :label="'employee.gross-annual-salary' | translate" class='mr-4'>
          <v-icon slot='left'>euro_symbol</v-icon>
        </text-field>
        <!--- <text-field v-model='professionClassification' :label="'employee.profession-classification' | translate" class='mr-4' /> -->
        <dropdown v-model="noRisk" :label="'employee.no-risk' | translate">
          <option :value="true">{{ "yes" | translate }}</option>
          <option :value="false">{{ "no" | translate }}</option>
        </dropdown>
      </div>
    </form-input-container>

    <div style="float: right" class='mt-5'>
      <Button primary   @click="this.handlePreviousClick" class="mr-3">{{ 'buttons.previous-step' | translate }}</Button>
      <Button secondary @click="this.handleContinueClick" :disabled="!isValid">{{ 'buttons.next-step' | translate }}</Button>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';

import NewEmployee from '@/views/constants/employee-new';
import { ProfessionClassification, NatureOfEmployment } from '@/resources/models/employment-relationships';

import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';
import TextField from '@aevitae/aevitaeui/0_atoms/input/TextField.vue';
import FormInputContainer from '@aevitae/aevitaeui/0_atoms/containers/FormInputContainer.vue';
import Dropdown from '@aevitae/aevitaeui/0_atoms/input/Dropdown.vue';
import RadioGroup from '@aevitae/aevitaeui/0_atoms/input/RadioGroup.vue';
import RadioGroupItem from '@aevitae/aevitaeui/0_atoms/input/RadioGroupItem.vue';
import DatePicker from '@aevitae/aevitaeui/1_molecules/Input/DatePicker.vue';

export default {
  name: 'NewEmployeePersonal',

  components: {
    Button,
    TextField,
    FormInputContainer,
    Dropdown,
    RadioGroup,
    RadioGroupItem,
    DatePicker
  },

  data () {
    return {
      professionClassifications: ProfessionClassification,
      naturesOfEmployment: NatureOfEmployment
    };
  },

  methods: {
    dispatchRelationshipChange (attribute, value) {
      this.$store.dispatch(
        NewEmployee.Actions.Form.RELATIONSHIP_CHANGE, {
          attribute: attribute,
          value: value
        }
      ).then(this.$store.dispatch(NewEmployee.Actions.Steps.Completed.UPDATE));
    },
    dispatchDetailChange (attribute, value) {
      this.$store.dispatch(
        NewEmployee.Actions.Form.DETAIL_CHANGE, {
          attribute: attribute,
          value: value
        }
      ).then(this.$store.dispatch(NewEmployee.Actions.Steps.Completed.UPDATE));
    },

    handleContinueClick () {
      this.$store.dispatch(NewEmployee.Actions.Navigate.DO, NewEmployee.Views.Confirmation);
    },
    handlePreviousClick () {
      this.$store.dispatch(NewEmployee.Actions.Navigate.DO, NewEmployee.Views.Personal);
    },

    handleSalaryChanged () {
      if (isNaN(parseFloat(this.grossAnnualSalary, 10))) {
      } else {
        if (this.grossAnnualSalary.indexOf(',') < 0) {
          this.grossAnnualSalary += ',00';
        } else {
          let splitGrossAnnualSalary = this.grossAnnualSalary.split(',');

          if (splitGrossAnnualSalary[1].length > 2) {
            splitGrossAnnualSalary[1] = splitGrossAnnualSalary[1].slice(0, 2);
          } else if (splitGrossAnnualSalary[1].length === 1) {
            splitGrossAnnualSalary[1] += '0';
          } else if (splitGrossAnnualSalary[1].length === 0) {
            splitGrossAnnualSalary[1] += '00';
          }

          this.grossAnnualSalary = splitGrossAnnualSalary.join(',');
        }
      }
      // this.grossAnnualSalary = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(this.grossAnnualSalary).
    }
  },

  computed: {
    ...mapGetters({
      newEmployee: 'newEmployee',
      relationship: 'newEmployeeEmploymentRelationship',
      // detail: 'newEmployeeEmploymentRelationshipDetail',

      relationshipValidations: 'newEmployeeEmploymentRelationshipValidations',
      relationshipRequiredFields: 'newEmployeeEmploymentRelationshipRequiredFields',

      detailValidations: 'newEmployeeEmploymentRelationshipDetailValidations',
      detailRequiredFields: 'newEmployeeEmploymentRelationshipDetailRequiredFields'
    }),

    detail () {
      return this.$store.getters.newEmployeeEmploymentRelationshipDetail;
    },

    isValid () {
      return this.relationshipValidations.isValid() && this.relationshipRequiredFields.isValid() &&
        this.detailValidations.isValid() && this.detailRequiredFields.isValid();
    },

    employeeNumber: {
      get () { return this.relationship.employeeNumber; },
      set (v) { this.dispatchRelationshipChange('employeeNumber', v); }
    },
    fromDate: {
      get () { return this.relationship.fromDate; },
      set (v) {
        this.dispatchRelationshipChange('fromDate', v);
        this.dispatchDetailChange('fromDate', v);
      }
    },
    untilDate: {
      get () { return this.relationship.untilDate; },
      set (v) { this.dispatchRelationshipChange('untilDate', v); }
    },
    absenceOnFromDate: {
      get () {
        return this.relationship.absenceOnFromDate;
      },
      set (v) { this.dispatchRelationshipChange('absenceOnFromDate', v); }
    },
    detailFromDate: {
      get () { return this.detail.fromDate; },
      set (v) { this.dispatchDetailChange('fromDate', v); }
    },
    natureOfEmployment: {
      get () { return this.detail.natureOfEmployment; },
      set (v) { this.dispatchDetailChange('natureOfEmployment', v); }
    },
    grossAnnualSalary: {
      get () { return this.detail.grossAnnualSalary; },
      set (v) {
        if (v != null) v = v.replace('.', ',');
        this.dispatchDetailChange('grossAnnualSalary', v);
      }
    },
    professionClassification: {
      get () { return this.detail.professionClassification; },
      set (v) { this.dispatchDetailChange('professionClassification', v); }
    },
    noRisk: {
      get () { return this.detail.noRisk; },
      set (v) { this.dispatchDetailChange('noRisk', v); }
    }
  }
};
</script>

<style lang='scss' scoped>
table {
  border-collapse: seperate;
}

p {
  font-size: 1em;
}

</style>
